import React from 'react';
import Fax from './index';
import ErrorBoundary from '../../../components/ErrorBoundary';

const FaxSend = React.lazy(() => import('./FaxSend'));

const FaxSendPage = (props) => (
  <Fax>
    <ErrorBoundary>
      <React.Suspense fallback={<div />}>
        <FaxSend {...props} />
      </React.Suspense>
    </ErrorBoundary>
  </Fax>
);

export default FaxSendPage;
